import { useTranslation } from "react-i18next";
import BaseDialog from "../../../common/base-dialog/base-dialog";

function MapModal({ open, setOpen, mapModalState }) {
    //general variables
    const { t } = useTranslation();

    return (
        <BaseDialog open={open} handleClose={() => setOpen(false)} maxWidth="md" top="auto">
            <iframe
                width="100%"
                height="400"
                src={`https://www.openstreetmap.org/export/embed.html?bbox=${mapModalState?.coordinates?.westLongitude},${mapModalState?.coordinates?.southLatitude},${mapModalState?.coordinates?.eastLongitude},${mapModalState?.coordinates?.northLatitude}&layer=mapnik&marker=${mapModalState?.latitude},${mapModalState?.longitude}`}
                style={{ border: "1px solid black" }}
            />
            <br />
            <small>
                <a
                    href={`https://www.openstreetmap.org/?mlat=${mapModalState?.latitude}&amp;mlon=${mapModalState?.longitude}#map=15/${mapModalState?.latitude}/${mapModalState?.longitude}`}
                    target="_blank"
                >
                    {t("zoomMap")}
                </a>
            </small>
        </BaseDialog>
    );
}

export default MapModal;
